import {
  titleUI,
  descriptionUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { AdditionalBenefitsSummaryDescription } from '../../content/additionalBenefits';

export default {
  uiSchema: {
    ...titleUI('You may be eligible for these other benefits'),
    ...descriptionUI(AdditionalBenefitsSummaryDescription),
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
